import React from "react";
import { FaRegCircle } from "react-icons/fa";
import { FaRegDotCircle } from "react-icons/fa";

const CurrencyPreference = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen gap-y-4">
      <h1 className="font-bold text-2xl capitalize">select currency</h1>
      <p className="w-72 text-sm text-center">
        Selecting a different currency will show prices that have been sourced
        primarily from sales in the selected currency.
      </p>
      <p className="w-72 text-center  text-sm">
        The locale from your device is{" "}
        <span className="font-bold">en-USwhich</span> suggests{" "}
        <span className="font-bold">USD</span> as a currency.
      </p>

      <div className="flex items-center justify-center gap-x-4">
        <button
          type="button"
          class="text-pinkColor hover:text-white border-2 border-pinkColor hover:bg-pinkColor focus:ring-4 focus:outline-none focus:ring-red-300 font-extrabold rounded-lg text-sm text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 uppercase px-2 py-3 flex items-center justify-center gap-x-2"
        >
          GBP(£)
          <FaRegCircle className="w-5" />
        </button>
        <button
          type="button"
          class="focus:outline-none text-white bg-pinkColor hover:bg-red-800 focus:ring-4 focus:ring-red-300 rounded-lg text-sm uppercase font-semibold px-2 py-3 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900 w-full  flex items-center justify-center gap-x-2"
        >
          usd($)
          <FaRegDotCircle />
        </button>
      </div>

      <p className="w-72 text-sm text-center">
        If there are currencies you would like to see added, join our discord
        and request them.
      </p>
    </div>
  );
};

export default CurrencyPreference;
